module.exports = __webpack_public_path__ + "img/icon-line-graph-blue.7e3167fd.svg";